import '@total-typescript/ts-reset';
import './styles/globals.css';
import './sentry';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { clearChunkReloadGuardSoon, isChunkLoadError, reloadOnStaleChunk } from './lib/chunkReload';

// Catches stale-chunk failures that surface as an unhandled promise rejection
// (e.g. Vite's own module-preload check). Failures thrown *during* a lazy
// route's render — the more common case — are caught instead by
// RouteErrorBoundary in routes/AppRouter.tsx, since React Router's
// RouterProvider consumes those internally before they ever reach here.
window.addEventListener('vite:preloadError', reloadOnStaleChunk);
window.addEventListener('unhandledrejection', (event) => {
  const message = String((event.reason as { message?: string } | undefined)?.message ?? event.reason ?? '');
  if (isChunkLoadError(message)) {
    reloadOnStaleChunk();
  }
});
clearChunkReloadGuardSoon();

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element with id "root" was not found');
}

const root = createRoot(container);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
